import React from 'react'
import { useSessionPermission } from '@btime/react-session'

import Grid, { Col } from '../../../../components/pdf/Grid'
import Text from '../../../../components/pdf/Text'
import GridBar from '../../../../components/pdf/GridBar'
import { getPercent } from '../_helpers/_helpers'

const Item = ({ label, value, total }) => (
  <Grid justify="center" gutter={3}>
    <Col gutter={3}>
      <Text noWrap>{label}:</Text>
    </Col>
    <Col gutter={3}>
      <Text bold inline>
        {value}
      </Text>
      {total && (
        <>
          <Text inline preLine style={{ whiteSpace: 'break-spaces' }}>
            {' '}
            de{' '}
          </Text>
          <Text bold inline style={{ whiteSpace: 'break-spaces' }}>
            {total}
          </Text>
        </>
      )}
    </Col>
  </Grid>
)

const CounterBar = ({ counters }) => {
  const hideAttendanceTime = useSessionPermission('hideAttendanceTime')

  return (
    <GridBar justify="space-between">
      <Item
        label="Pontuação"
        value={`${getPercent(counters.countersOfValues, counters.countersOfPoints)}%`}
        total={'100%'}
      />
      {!hideAttendanceTime && <Item label="Tempo" value={counters.attendanceTime} />}
    </GridBar>
  )
}

export default CounterBar
